import { TextField } from "@mui/material";

type TimeFieldProps = {
	name: string;
	value: string;
	handleOnChange: (event: any) => void;
	error: boolean;
	required: boolean;
	helperText?: string;
};

export const TimeField = (props: TimeFieldProps) => {
	const { name, value, handleOnChange, error, required, helperText } = props;

	const handleChange = (event: any, name: string) => {
		event.target.id = name;
		if (event.nativeEvent.inputType === "insertText") {
			event.target.value = addDelimeter(event.target.value);
		}
		handleOnChange(event);
	};

	const addDelimeter = (value: string): string => {
		if (value.length === 2) return value + ":";
		if (value.length === 5) return value + ":";
		if (value.length > 8) return value.slice(0, 8);
		return value;
	};

	return (
		<TextField
			id={name}
			label={name}
			value={value}
			onChange={(event) => handleChange(event, name)}
			required={required}
			error={error}
			helperText={error && helperText}
			placeholder="HH:MM:SS"
		/>
	);
};
